export const FETCH_BOOKING_DATES = 'FETCH_BOOKING_DATES';
export const FETCH_INDUSTRIES_BIG5 = 'FETCH_INDUSTRIES_BIG5';
export const SET_PRODUCT_FILTER_DATA = 'SET_PRODUCT_FILTER_DATA';
export const CLEAR_PRODUCT_FILTER_DATA = 'CLEAR_PRODUCT_FILTER_DATA';
export const START_FETCH_PRODUCTS = `START_FETCH_PRODUCTS`;
export const FETCH_PRODUCTS = `FETCH_PRODUCTS`;
export const FETCHED_BOOKING_DATES = `FETCHED_BOOKING_DATES`;
export const UPDATE_BATCH_EDIT_FAILED_COUNT = `UPDATE_BATCH_EDIT_FAILED_COUNT`;
export const FETCHED_PRODUCT_PRICE = `FETCHED_PRODUCT_PRICE`;
export const FETCHED_DIGITAL_PRODUCT_AVAILABILITY = `FETCHED_DIGITAL_PRODUCT_AVAILABILITY`;
export const CALCULATE_SHARE_OF_TIME = `CALCULATE_SHARE_OF_TIME`;

export const TIMESLOT_OPTIONS = [
  {
    title: 'Day',
    value: '05:00 bis 01:00 Uhr',
    className: 'border-bottom',
    timeslot: 1,
  },
  { title: 'Primetime morning', value: '05:00 bis 09:00 Uhr', timeslot: 11 },
  { title: 'Shopping', value: '09:00 bis 16:00 Uhr', timeslot: 12 },
  { title: 'Primetime evening', value: '16:00 bis 20:00 Uhr', timeslot: 13 },
  { title: 'Evening', value: '20:00 bis 01:00 Uhr', timeslot: 14 },
];

export const TIMESLOT_CART_OPTIONS = [
  {
    title: 'Day',
    value: '05:00 - 01:00',
    className: 'border-bottom',
    timeslot: 1,
  },
  { title: 'Primetime morning', value: '05:00 - 09:00', timeslot: 11 },
  { title: 'Shopping', value: '09:00 - 16:00', timeslot: 12 },
  { title: 'Primetime evening', value: '16:00 - 20:00', timeslot: 13 },
  { title: 'Evening', value: '20:00 - 01:00', timeslot: 14 },
];

export const OPEN_BASKET = 'OPEN_BASKET';
export const CLOSE_BASKET = 'CLOSE_BASKET';
export const CREATE_BASKET = 'CREATED_BASKET';
export const FETCH_BASKET = 'FETCHED_BASKET';
export const UPDATE_BASKET_DATA = 'UPDATE_BASKET_DATA';
export const CLEAR_BASKET = 'CLEAR_BASKET';
export const REMOVE_FROM_BASKET = 'REMOVED_FROM_BASKET';
export const REMOVE_BASKET_DATA = 'REMOVE_BASKET_DATA';
export const ADD_TO_BASKET = 'ADD_TO_BASKET';
export const FETCH_ERROR = 'FETCH_ERROR';
export const POST_ERROR = 'POST_ERROR';
export const RESET_ALL = 'RESET_ALL';
export const UPDATE_BASKET_DEFINITION = `UPDATE_BASKET_DEFINITION`;
export const UPDATE_PRODUCT_BASKET_ENTRY = `UPDATE_PRODUCT_BASKET_ENTRY`;

export const BATCH_SELECT_GROUP = 'BATCH_SELECT_GROUP';
export const BATCH_DESELECT_GROUP = 'BATCH_DESELECT_GROUP';
export const BATCH_SELECT_PRODUCT = 'BATCH_SELECT_PRODUCT';
export const BATCH_DESELECT_PRODUCT = 'BATCH_DESELECT_PRODUCT';
export const DESELECT_ALL_PRODUCTS_AND_GROUPS = 'DESELECT_ALL_PRODUCTS_AND_GROUPS';

export const FILTERING_PRODUCTS = 'FILTERING_PRODUCTS';
export const CLEAR_FILTERED_PRODUCTS = 'CLEAR_FILTERED_PRODUCTS';
export const CLEAR_FILTERED_PRODUCTS_BY_TYPE = 'CLEAR_FILTERED_PRODUCTS_BY_TYPE';
export const SELECT_ALL_FILTERED_PRODUCTS_BY_TYPE = 'SELECT_ALL_FILTERED_PRODUCTS_BY_TYPE';

export const NOTICE_RECEIVED = 'NOTICE_RECEIVED';
export const CLEAR_NOTICES = 'CLEAR_NOTICES';
export const GET_FILTERS = 'GET_FILTERS';

export const ADD_ABORT_CONTROLLER = 'ADD_ABORT_CONTROLLER';
